import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CredencialesService {
  private endpoint: string = environment.backend.service.credenciales.url;

  constructor(
    private http: HttpClient,
  ) { }

  validacionLink(idOrganizacion: string = '', idTransaccion: string = ''): Observable<any> {
    let params = new HttpParams(); 
    params = params.append("idTransaccionEncrypted", idTransaccion);
    params = params.append("idOrganizacionEncrypted", idOrganizacion);

    const headers = new HttpHeaders().set("requestOrigin", "WEB")

    return this.http.get<any>(`${this.endpoint}iniciarSincronizacion`, { params, headers })
  }

  iniciarSincronizacion(
    rut: string, 
    idOrganizacionEncrypted: string, 
    idTransaccionEncrypted: string, 
    emailDestino: string, 
    servicioSolicitado: string,
    aceptaTerminos: boolean,
    credsObject: any
  ): Observable<any> {

    const payload: any = {
      rut: rut,
      idOrganizacionEncrypted: idOrganizacionEncrypted,
      idTransaccionEncrypted: idTransaccionEncrypted,
      emailDestino: emailDestino,
      servicioSolicitado: servicioSolicitado,
      aceptaTerminos: aceptaTerminos,
      credsObject: credsObject
    }

    const headers = new HttpHeaders().set("requestOrigin", "WEB")

    return this.http.post<any>(`${this.endpoint}sincronizarCredencialesEtapa1`, payload, { headers: headers });
  }

  iniciarSincronizacionEtapa2(
    rut: string, 
    idOrganizacionEncrypted: string, 
    idTransaccionEncrypted: string, 
    emailDestino: string, 
    servicioSolicitado: string,
    aceptaTerminos: boolean,
    credsObject: any
  ): Observable<any> {

    const payload: any = {
      rut: rut,
      idOrganizacionEncrypted: idOrganizacionEncrypted,
      idTransaccionEncrypted: idTransaccionEncrypted,
      emailDestino: emailDestino,
      servicioSolicitado: servicioSolicitado,
      aceptaTerminos: aceptaTerminos,
      credsObject: credsObject
    }

    const headers = new HttpHeaders().set("requestOrigin", "WEB")

    return this.http.post<any>(`${this.endpoint}sincronizarCredencialesEtapa2`, payload, { headers: headers });
  }
}
